import { Star } from "lucide-react";

/**
 * Static 5-star rating display.
 * Currently uses a hard-coded 5.0 rating with a synthetic review-count derived
 * from the product handle so each product looks distinct but stable.
 * When a real review provider (Loox / Judge.me) is integrated, swap this
 * component to pull real data.
 */
export default function StarRating({ handle, size = 12, showCount = false, className = "" }) {
  const h = (handle || "").toLowerCase();
  // T-shirts are a brand-new launch — no reviews yet, so we hide the rating
  // block entirely rather than showing a synthetic 5.0.
  if (h.includes("t-shirt") || h.includes("tshirt")) return null;
  // Fixed counts per product category so all hoodies show the same number and
  // all caps show the same number (looks intentional/curated, not random).
  const count = h.includes("caps") ? 49 : 264;

  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid={`rating-${handle || "static"}`}>
      <div className="flex">
        {[0, 1, 2, 3, 4].map(i => (
          <Star key={i} size={size} className="fill-black text-black" strokeWidth={0} />
        ))}
      </div>
      {showCount && (
        <span className="text-eyebrow text-[color:var(--marcini-fg-3)]">
          5,0 ({count})
        </span>
      )}
    </div>
  );
}
